// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__HLhNI","iconWrapper":"style_iconWrapper__o5Osw","title":"style_title__9aKby","codeWrapper":"style_codeWrapper__36jEg","actions":"style_actions__cPjiT"};